<div>
  <div class="yearhead">
    <div class="arrows prev-mth" [class]="datepicker_serv.getClassName(field.arrowClassName)" (click)="prevYear()"></div>
    <button [class]="datepicker_serv.getClassName(field.yearBtnHeadClassName)" (click)="changeYear(showYear)">{{ showYear }}</button>
    <div class="arrows next-mth" [class]="datepicker_serv.getClassName(field.arrowClassName)" (click)="nextYear()" ></div>
  </div>
  <div  class="year">
    <div *ngFor="let y of arrayYear; let i=index;" class="yearlist" [class]="datepicker_serv.getClassName(field.yearListClassName)" (click)="changeYear(y)" [class.selected]="y ==selectedYear" [class.today]="y == currentYear"  >{{y}}</div>
  </div>
</div>
